import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { getVisibleTabs } from '../../utils/tournamentPhases';

/**
 * TournamentTabBar - Horizontal scrollable tab bar for portal tournament detail.
 * Tabs appear/disappear based on the tournament's portalStatus.
 */
const TournamentTabBar = ({ portalStatus }) => {
  const { tournamentId } = useParams();
  const tabs = getVisibleTabs(portalStatus);
  const basePath = `/portal/tournaments/${tournamentId}`;

  const tabPaths = {
    activity: basePath,
    request: `${basePath}/request`,
    teesheet: `${basePath}/teesheet`,
    sideaction: `${basePath}/sideaction`,
    recap: `${basePath}/recap`,
    feedback: `${basePath}/feedback`,
  };

  return (
    <nav className="overflow-x-auto border-b border-gray-200 bg-white sticky top-[52px] z-30">
      <div className="flex min-w-max px-4">
        {tabs.map((tab) => (
          <NavLink
            key={tab.id}
            to={tabPaths[tab.id]}
            end={tab.id === 'activity'}
            className={({ isActive }) =>
              [
                'px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors',
                isActive
                  ? 'border-green-600 text-green-700'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
              ].join(' ')
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default TournamentTabBar;
